export type LogoTypeKey =
    | 'wordmark'
    | 'mascot'
    | 'emblem'
    | 'abstract'
    | 'symbol'
    | 'combo'
    | 'open-to-ideas';

export interface LogoType {
    key: LogoTypeKey;
    title: string;
    description: string;
    imageSrc: string;
    attribution?: string;
}

export default [
    {
        key: 'wordmark',
        title: 'Wordmark',
        description: 'Unique typographic treatments help them remember your name.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/wordmark.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: 'by VU design',
    },
    {
        key: 'pictorial',
        title: 'Pictorial',
        description: 'Link your business with the image of your choice: instant brand personality.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/pictorial.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: 'by milan artworks',
    },
    {
        key: 'abstract',
        title: 'Abstract',
        description: 'Truly custom abstract images stand for you and you alone.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/abstract.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: 'by Fulcro',
    },
    {
        key: 'mascot',
        title: 'Mascot',
        description: 'Fun brands start with a memorable character.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/mascot.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: 'by Crealiza',
    },
    {
        key: 'emblem',
        title: 'Emblem',
        description: 'Build a legacy with a badge, seal or crest.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/emblem.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: 'by Dexterous"',
    },
    {
        key: 'combination',
        title: 'Combination',
        description: 'Words and images mixed together to create the perfect combo.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/combination.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
        attribution: 'by Rozak ifandi',
    },
    {
        key: 'open-to-ideas',
        title: 'Open to ideas',
        description: 'I’d like to see different concepts to decide what works for my brand.',
        imageSrc:
            'https://99designs-start-static.imgix.net/logo-interactive/not-sure-yet.jpg?auto=format&ch=Width%2CDPR&w=224&h=224&dpr=2',
    },
];
